/**
 * @file ClinicViewModel.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import { Subject } from "rxjs";
import ViewModel from "../../../base/ViewModel";
import { ApiError } from "../../../../services/models/ApiError";
import { GenericResponse } from "../../../../services/models/GenericResponse";
import { ClinicRequet } from "../../../../services/models/ClinicRequet";

/**
 * A class definition for ViewModel ClinicViewModel
 */
export class ClinicViewModel extends ViewModel {

  /* Clinic create response */
  onClinicCreated = new Subject<GenericResponse>();
  onClinicCreatedError = new Subject<ApiError>();

  onClinicEdited = new Subject<GenericResponse>();
  onClinicEditedError = new Subject<ApiError>();  

  constructor() {
    super();
  }

  /**
    * Creates a clinic
    * @param clinicRequest ClinicRequet
    * @param accessToken string
    */
  async createClinic(clinicRequest: ClinicRequet, accessToken: string){
        try {
            const response = await this.apiService.createClinic(clinicRequest, accessToken);
            this.onClinicCreated.next(response as GenericResponse)
        } catch (error: unknown) {
            this.onClinicCreatedError.next(error as ApiError)
        }
    }

  /**
    * Edit a clinic
    * @param clinicRequest ClinicRequet
    * @param accessToken string
    */
  async editClinic(name: string, clinicId: string, accessToken: string){
    try {
        const response = await this.apiService.editClinic(name,clinicId, accessToken);
        this.onClinicEdited.next(response as GenericResponse)
    } catch (error: unknown) {
        this.onClinicEditedError.next(error as ApiError)
    }
    
}    
}
